module.exports = __webpack_public_path__ + "static/media/bannerImage1-l.38e2075a.jpg";